window.addEventListener("DOMContentLoaded", function () {
    if (localStorage.getItem("footer-click-faq")) {
        var sidebarFaqId = localStorage.getItem("footer-click-faq");
        var sidebarFaqTab = document.querySelector(
            ".lux-sidebar-tab.faq-" + sidebarFaqId,
        );

        localStorage.removeItem("footer-click-faq");

        if (sidebarFaqTab) {
            sidebarFaqTab instanceof HTMLElement && sidebarFaqTab.click();
        }
    }
});
